// СГЕНЕРИРОВАНО АВТОМАТИЧЕСКИ — не редактировать.
// Источник: packages/contracts/python/taskflow_contracts/enums.py
// Обновить: python3 packages/contracts/scripts/generate_ts.py


/** §20.2. Членство на доске. */
export const BoardMemberStatus = {
  ACTIVE: "ACTIVE",
  REMOVED: "REMOVED",
} as const;
export type BoardMemberStatus = (typeof BoardMemberStatus)[keyof typeof BoardMemberStatus];

/** §6.3. Встроенные роли на доске. */
export const BoardRoleCode = {
  OWNER: "board_owner",
  MODERATOR: "moderator",
  MEMBER: "member",
  OBSERVER: "observer",
} as const;
export type BoardRoleCode = (typeof BoardRoleCode)[keyof typeof BoardRoleCode];

/** §2.2. Базовые подразделения seed. Остальные заводит администратор, */
export const DepartmentCode = {
  OA: "OA",
  OOA: "OOA",
  OAP: "OAP",
} as const;
export type DepartmentCode = (typeof DepartmentCode)[keyof typeof DepartmentCode];

/** Общий статус справочных сущностей: активна или архивна. */
export const EntityStatus = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
} as const;
export type EntityStatus = (typeof EntityStatus)[keyof typeof EntityStatus];

/** §17.9. Форматы экспорта. Настоящие, не имитация одного другим. */
export const ExportFormat = {
  PDF: "PDF",
  XLSX: "XLSX",
  DOCX: "DOCX",
} as const;
export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];

export const ExportJobStatus = {
  PENDING: "PENDING",
  RUNNING: "RUNNING",
  READY: "READY",
  FAILED: "FAILED",
} as const;
export type ExportJobStatus = (typeof ExportJobStatus)[keyof typeof ExportJobStatus];

/** §4.4. Машина состояний приглашения. */
export const InvitationStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  REVOKED: "REVOKED",
  EXPIRED: "EXPIRED",
} as const;
export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus];

/** Приглашение в заметку: доступ появляется только после принятия. */
export const NoteMemberStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
} as const;
export type NoteMemberStatus = (typeof NoteMemberStatus)[keyof typeof NoteMemberStatus];

/** Доступ к заметке. Автор — всегда OWNER; приглашённый — VIEW или EDIT. */
export const NoteRole = {
  OWNER: "OWNER",
  EDIT: "EDIT",
  VIEW: "VIEW",
} as const;
export type NoteRole = (typeof NoteRole)[keyof typeof NoteRole];

/** Порядок списка заметок. Закреплённые всегда выше остальных. */
export const NoteSort = {
  UPDATED: "UPDATED",
  CREATED: "CREATED",
  TITLE: "TITLE",
} as const;
export type NoteSort = (typeof NoteSort)[keyof typeof NoteSort];

/** §18.1. Категории уведомлений — по ним настраиваются предпочтения. */
export const NotificationCategory = {
  ASSIGNED: "ASSIGNED",
  UNASSIGNED: "UNASSIGNED",
  MENTIONED: "MENTIONED",
  COMMENT: "COMMENT",
  OVERDUE: "OVERDUE",
  TASK_REMINDER: "TASK_REMINDER",
  STATUS_CHANGED: "STATUS_CHANGED",
  FIELDS_CHANGED: "FIELDS_CHANGED",
  ATTACHMENT: "ATTACHMENT",
  SUBTASK: "SUBTASK",
  ARCHIVED: "ARCHIVED",
  RESTORED: "RESTORED",
  BOARD_INVITE: "BOARD_INVITE",
  NOTE_INVITE: "NOTE_INVITE",
  NOTE_REMINDER: "NOTE_REMINDER",
  VACATION_UPCOMING: "VACATION_UPCOMING",
  VACATION_CONFLICT: "VACATION_CONFLICT",
  VACATION_CHANGED: "VACATION_CHANGED",
  TASK_CREATED: "TASK_CREATED",
  TASK_DELETED: "TASK_DELETED",
} as const;
export type NotificationCategory = (typeof NotificationCategory)[keyof typeof NotificationCategory];

/** §29.1. Системные статусные теги ОАП. Коды неизменяемы. */
export const OapStatusCode = {
  PLANNED: "planned",
  IN_PROGRESS: "in_progress",
  ON_CONTROL: "on_control",
  COMPLETED: "completed",
} as const;
export type OapStatusCode = (typeof OapStatusCode)[keyof typeof OapStatusCode];

/** Ручная отметка дня в производственном календаре. Нет отметки — */
export const ProductionDayKind = {
  WORK: "WORK",
  OFF: "OFF",
} as const;
export type ProductionDayKind = (typeof ProductionDayKind)[keyof typeof ProductionDayKind];

/** §8.3. Режим привязки проекта. */
export const ProjectBindingMode = {
  BOARD: "BOARD",
  COLUMN: "COLUMN",
} as const;
export type ProjectBindingMode = (typeof ProjectBindingMode)[keyof typeof ProjectBindingMode];

/** §17.3. Периоды отчётности. */
export const ReportPeriod = {
  WEEK: "WEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  YEAR: "YEAR",
  CUSTOM: "CUSTOM",
} as const;
export type ReportPeriod = (typeof ReportPeriod)[keyof typeof ReportPeriod];

/** §20.2. Область действия роли. */
export const RoleScope = {
  SYSTEM: "SYSTEM",
  BOARD: "BOARD",
} as const;
export type RoleScope = (typeof RoleScope)[keyof typeof RoleScope];

/** Категория столбца для досок со статусом из колонки. */
export const StatusCategory = {
  BACKLOG: "BACKLOG",
  OPEN: "OPEN",
  PLANNED: "PLANNED",
  IN_PROGRESS: "IN_PROGRESS",
  REVIEW: "REVIEW",
  DONE: "DONE",
  RELEASED: "RELEASED",
  CLOSED: "CLOSED",
} as const;
export type StatusCategory = (typeof StatusCategory)[keyof typeof StatusCategory];

/** §2.4. Откуда берётся статус задачи. */
export const StatusSource = {
  COLUMN: "COLUMN",
  SYSTEM_TAG: "SYSTEM_TAG",
} as const;
export type StatusSource = (typeof StatusSource)[keyof typeof StatusSource];

/** §6.2. Встроенные системные роли. Не удаляются. */
export const SystemRoleCode = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
} as const;
export type SystemRoleCode = (typeof SystemRoleCode)[keyof typeof SystemRoleCode];

/** §10. Вид тега доски. */
export const TagKind = {
  REGULAR: "REGULAR",
  SYSTEM_STATUS: "SYSTEM_STATUS",
} as const;
export type TagKind = (typeof TagKind)[keyof typeof TagKind];

/** §20.5. События задачи. Append-only, основа истории и отчётности. */
export const TaskEventType = {
  TASK_CREATED: "TASK_CREATED",
  TASK_UPDATED: "TASK_UPDATED",
  TASK_MOVED: "TASK_MOVED",
  ASSIGNEES_CHANGED: "ASSIGNEES_CHANGED",
  STATUS_CHANGED: "STATUS_CHANGED",
  TAGS_CHANGED: "TAGS_CHANGED",
  LINK_ADDED: "LINK_ADDED",
  LINK_REMOVED: "LINK_REMOVED",
  COMMENT_ADDED: "COMMENT_ADDED",
  COMMENT_EDITED: "COMMENT_EDITED",
  COMMENT_DELETED: "COMMENT_DELETED",
  FILE_ADDED: "FILE_ADDED",
  FILE_DELETED: "FILE_DELETED",
  TASK_ARCHIVED: "TASK_ARCHIVED",
  TASK_RESTORED: "TASK_RESTORED",
} as const;
export type TaskEventType = (typeof TaskEventType)[keyof typeof TaskEventType];

/** §13.1. Типы связей между задачами. */
export const TaskLinkType = {
  BLOCKS: "BLOCKS",
  BLOCKED_BY: "BLOCKED_BY",
  RELATES_TO: "RELATES_TO",
  DUPLICATES: "DUPLICATES",
  DUPLICATED_BY: "DUPLICATED_BY",
  PARENT_OF: "PARENT_OF",
  CHILD_OF: "CHILD_OF",
} as const;
export type TaskLinkType = (typeof TaskLinkType)[keyof typeof TaskLinkType];

/** Сворачиваемые блоки карточки задачи. */
export const TaskSection = {
  ATTACHMENTS: "ATTACHMENTS",
  LINKS: "LINKS",
  PARAMETERS: "PARAMETERS",
  COMMENTS: "COMMENTS",
  HISTORY: "HISTORY",
} as const;
export type TaskSection = (typeof TaskSection)[keyof typeof TaskSection];

export const ThemePreference = {
  LIGHT: "LIGHT",
  DARK: "DARK",
  SYSTEM: "SYSTEM",
} as const;
export type ThemePreference = (typeof ThemePreference)[keyof typeof ThemePreference];

/** §5.4. Состояния пользователя. */
export const UserStatus = {
  INVITED: "INVITED",
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
  DEACTIVATED: "DEACTIVATED",
} as const;
export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

/** Как считаются дни отпуска для лимита. */
export const VacationCountMode = {
  CALENDAR: "CALENDAR",
  WORK: "WORK",
} as const;
export type VacationCountMode = (typeof VacationCountMode)[keyof typeof VacationCountMode];

/** Правила отпуска: код в details.rule ошибки и в списке предупреждений. */
export const VacationRule = {
  DATES_ORDER: "DATES_ORDER",
  OUT_OF_YEAR: "OUT_OF_YEAR",
  OVERLAP: "OVERLAP",
  LIMIT_EXCEEDED: "LIMIT_EXCEEDED",
  MAX_PERIODS: "MAX_PERIODS",
  NO_LONG_PERIOD: "NO_LONG_PERIOD",
  CONFLICT: "CONFLICT",
  COLOR_TAKEN: "COLOR_TAKEN",
} as const;
export type VacationRule = (typeof VacationRule)[keyof typeof VacationRule];

/** Вид отпуска. Оба учитываются в личном лимите дней. */
export const VacationType = {
  MAIN: "MAIN",
  EXTRA: "EXTRA",
} as const;
export type VacationType = (typeof VacationType)[keyof typeof VacationType];

/** Поводы уведомлений подписки на столбец, доску или проект. */
export const WatchEvent = {
  TASK_CREATED: "TASK_CREATED",
  COMMENT: "COMMENT",
  STATUS: "STATUS",
  ASSIGNEES: "ASSIGNEES",
  DUE_DATE: "DUE_DATE",
  OVERDUE: "OVERDUE",
  MOVED: "MOVED",
  ARCHIVED: "ARCHIVED",
  DELETED: "DELETED",
} as const;
export type WatchEvent = (typeof WatchEvent)[keyof typeof WatchEvent];

/** Что наблюдается. TASK — прежние «Наблюдатели» карточки задачи: */
export const WatchTargetType = {
  TASK: "TASK",
  COLUMN: "COLUMN",
  BOARD: "BOARD",
  PROJECT: "PROJECT",
} as const;
export type WatchTargetType = (typeof WatchTargetType)[keyof typeof WatchTargetType];

/** Обратное представление связи (§13.1) */
export const LINK_INVERSE: Record<TaskLinkType, TaskLinkType> = {
  BLOCKS: "BLOCKED_BY",
  BLOCKED_BY: "BLOCKS",
  RELATES_TO: "RELATES_TO",
  DUPLICATES: "DUPLICATED_BY",
  DUPLICATED_BY: "DUPLICATES",
  PARENT_OF: "CHILD_OF",
  CHILD_OF: "PARENT_OF",
};
